import { Button, Heading, Input, Text } from '@chakra-ui/react';

import { Alert, Link, VStack } from '@/components';

import { useLogin } from './Login.hooks';
import { loginCss } from './Login.styles';

export const Login = () => {
  const {
    username,
    setUsername,
    password,
    setPassword,
    error,
    isValid,
    isSubmitting,
    handleSubmit,
    ssoLoginUrl,
  } = useLogin();

  return (
    <VStack as="form" className="Login" css={loginCss} onSubmit={handleSubmit}>
      <VStack gap={1}>
        <Heading as="h2" size="lg">
          Sign in
        </Heading>
        <Text textStyle="sm" color="fg.muted">
          {ssoLoginUrl
            ? 'Use your company Google account, or your email address and password.'
            : 'Use your email address and password.'}
        </Text>
      </VStack>

      {error && <Alert status="error" title={error} />}

      {ssoLoginUrl && (
        <>
          <Button asChild colorPalette="accent" pill width="full">
            <a href={ssoLoginUrl}>Sign in with Google</a>
          </Button>
          <Text textStyle="sm" color="fg.muted">
            or
          </Text>
        </>
      )}

      <Input
        name="username"
        aria-label="username"
        autoComplete="username"
        placeholder="Email"
        value={username}
        onChange={({ target: { value } }) => setUsername(value)}
      />
      <Input
        name="password"
        aria-label="password"
        placeholder="Password"
        type="password"
        autoComplete="current-password"
        value={password}
        onChange={({ target: { value } }) => setPassword(value)}
      />

      <Button
        type="submit"
        colorPalette="accent"
        pill
        width="full"
        disabled={!isValid || isSubmitting}
        loading={isSubmitting}
      >
        Log in
      </Button>

      <Link
        to="../forgot-password"
        variant="underline"
        className="forgot-password"
      >
        Forgot password?
      </Link>
    </VStack>
  );
};
